// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__owitg","col":"styles_col__zb42_","actions":"styles_actions__3tuAQ","conflict":"styles_conflict__1BfLp"};